import React from 'react';
import PropTypes from 'prop-types';
export var Component = function Component(_ref) {
  var children = _ref.children;
  return React.createElement("span", {
    className: "ui sub header"
  }, children);
};
Component.displayName = 'Subheading';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.string.isRequired
} : {};